import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { AnalyticsService, ApprovalsService, AuthenticationService, DataService, LoansService, OperationsService, StorageService } from '../_services';

@Component({
  selector: 'app-wema-payments',
  templateUrl: './wema-payments.component.html',
  styleUrls: ['./wema-payments.component.css']
})
export class WemaPaymentsComponent implements OnInit {

  loading = false;
  start_date = '';
  customers:any;
  currentUser:any;
  account_number = '';
  amount = '';
  session_id ='';
  start = '0';


  constructor(public analytics: AnalyticsService, public approvalService: ApprovalsService, public DataService: DataService, public loansService: LoansService,
    public router: Router, public fb: FormBuilder, public operationsService: OperationsService, public authService: AuthenticationService,
    public storageService: StorageService) { 
      this.currentUser = this.storageService.read<any>('currentUser')
    }

  ngOnInit() {
    //this.getCyberpayPayments(); 
  }

  getCyberpayPayments() {

    this.loading = true;
    this.loansService.getWemaLivetransactions(this.start_date, this.account_number, this.amount, this.session_id)
      .subscribe(res => {
        this.loading = false;
        this.customers = res.records;
        this.start = res.start;
      });

  }

}
